module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('v-style', [_vm._v("\n        #app > .builderContainer { display: block; } #builderWrapper { height: 100%; width: 100%; } .content-builder-main { position: unset; }\n    ")]), _vm._v(" "), _c('MenuBar', {
    attrs: {
      "background-color-active": "#A2A2A2"
    }
  }, [_c('MenuItemPlano', {
    attrs: {
      "icon": "fas fa-file-pdf",
      "size": 50,
      "width": 400,
      "action": _vm.exportPdf,
      "text": _vm.$t('planobuilder.export')
    }
  })], 1), _vm._v(" "), _c('section', [_c('TemplatePlano', {
    staticClass: "plano",
    attrs: {
      "data": _vm.getMeuble
    }
  }), _vm._v(" "), _c('aside', [_c('ul', {
    staticClass: "listNone listAction"
  }, [_c('li', {
    staticClass: "selection",
    class: {
      on: !_vm.isPan
    },
    on: {
      "click": _vm.activeSelection
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "pan",
    class: {
      on: _vm.isPan
    },
    on: {
      "click": _vm.activePan
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "listNone listZoom"
  }, [_c('li', {
    staticClass: "zoom-position",
    class: {
      on: _vm.isZoomComponent()
    },
    on: {
      "click": _vm.zoomComponent
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "zoom-extent",
    on: {
      "click": _vm.planoInit
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "listNone listOption"
  }, [_c('li', {
    staticClass: "icon-layers snap",
    class: {
      on: _vm.hasSnapMod
    },
    on: {
      "click": _vm.activeSnapMod
    }
  }), _vm._v(" "), (!_vm.isCaddySystem) ? _c('li', {
    staticClass: "icon-layers overhang",
    class: {
      on: _vm.hasOverHang
    },
    on: {
      "click": _vm.activeOverHang
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isCaddySystem) ? _c('li', {
    staticClass: "icon-layers span",
    class: {
      on: _vm.hasOverHang
    },
    on: {
      "click": _vm.activeOverHang
    }
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "icon-layers free-position",
    class: {
      on: _vm.isFreePosition
    },
    on: {
      "click": _vm.activeFreePosition
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "listNone listLayers"
  }, [_c('li', {
    staticClass: "icon-layers layers",
    class: {
      on: _vm.isActiveLayer
    },
    on: {
      "click": _vm.activeLayers
    }
  })])])], 1), _vm._v(" "), _c('MenuBar', {
    attrs: {
      "id": "menu_plano_massmarket",
      "background-color-active": "#A2A2A2"
    }
  }, [_c('MenuItemPlano', {
    attrs: {
      "id": "menuitem_plano_massmarket_lib",
      "icon": "fas fa-grip-vertical",
      "size": 50,
      "width": 400,
      "text": _vm.$t('planobuilder.library')
    }
  }, [_c('Elements', {
    staticClass: "menu-element",
    attrs: {
      "plano": 1
    }
  })], 1), _vm._v(" "), _c('MenuItemPlano', {
    attrs: {
      "id": "menuitem_plano_massmarket_scratchpad",
      "icon": "fas fa-paste",
      "size": 50,
      "width": 400,
      "text": _vm.$t('planobuilder.scratch')
    }
  }, [_c('Favorite', {
    attrs: {
      "type": "SCRATCHPAD",
      "idPlano": parseInt(_vm.$route.params.id, 10),
      "typePlano": "WALL"
    }
  })], 1), _vm._v(" "), _c('MenuItemPlano', {
    attrs: {
      "id": "menuitem_plano_massmarket_fav",
      "icon": "fas  fa-bookmark",
      "size": 50,
      "width": 400,
      "text": _vm.$t('planobuilder.favorite')
    }
  }, [_c('Favorite', {
    attrs: {
      "typePlano": "WALL"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22cbb340","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/PlanoEditorMassMarket.vue
// module id = 3078
// module chunks = 0